class Breadcrumbs {
  constructor() {
    this.init();
  }

  init() {
    const breadcrumbsList = document.querySelector('.breadcrumbs__list');
    if (!breadcrumbsList) return;

    const items = breadcrumbsList.querySelectorAll('.breadcrumbs__item');
    if (!items.length) return;

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: []
    };

    items.forEach((item, index) => {
      const link = item.querySelector('.breadcrumbs__link');
      if (!link) return;
      structured.itemListElement.push({
        '@type': 'ListItem',
        position: index + 1,
        name: link.textContent.trim(),
        item: link.href
      });
    });

    if (structured.itemListElement.length > 0) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structured);
      document.head.appendChild(script);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Breadcrumbs();
});
